module.exports = __webpack_public_path__ + "static/media/UniMarburg.afec34f5.svg";